var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Empresas","p-read-link":"companies.read.one","p-create-link":"companies.create","p-name":"companies"}})}
var staticRenderFns = []

export { render, staticRenderFns }